export default {
  props: [
    'isGWP',
    'formattedPrice',
    'formattedDiscountPrice',
    'fullPriceValueText',
    'fullPriceValueTextHTML',
  ],
  template: `
    <div
      v-if="!isGWP"
      class="product-card__details__pricing-info OneLinkNoTx f"
    >
      <span
        data-bundle-price
        class="p1 bold product-card__details__price"
        :class="{ 'discounted': formattedDiscountPrice && formattedDiscountPrice !== formattedPrice }"
        v-text="formattedPrice"
        :aria-label="'Price: ' + formattedPrice"
      >
      </span>
      <span
        v-if="formattedDiscountPrice && formattedDiscountPrice !== formattedPrice"
        class="p1 bold product-card__details__discount-price red"
        :aria-label="'Discounted Price: ' + formattedDiscountPrice"
        v-text="formattedDiscountPrice">
      </span>
      <span
        v-if="fullPriceValueTextHTML"
        class="p1 product-card__details__full-price"
        :aria-label="'Full Price: ' + fullPriceValueText"
        v-html="fullPriceValueText">
      </span>
    </div>
  `,
};
